const AppGetterTypes = {
    version: "version",
    environmentAlert: "environmentAlert",
    validationRules: "validationRules",
    getModelValidationRules: "getModelValidationRules",
    getPropertyValidationRules: "getPropertyValidationRules",
    raygunApiKey: "raygunApiKey",
    user: "user"
};

export default AppGetterTypes;
